import { usePunditUserContext } from "@circle-react/contexts";
import { useIsMemberToMemberMessagingEnabled } from "@circle-react/hooks/useIsMessagingEnabled";
import type { Member } from "@circle-react/types/Chat/Member";

// Note:
// This hook can still return true if member messaging is disabled and
// they do not have an existing chat room with the admin.
export const useCanMessageMember = ({
  member,
  shouldHideMessageButton = false,
}: {
  member: Member;
  shouldHideMessageButton?: boolean;
}) => {
  const { currentCommunityMember, currentCommunity } = usePunditUserContext();

  const isSenderAdmin = currentCommunityMember?.is_admin;
  const isReceiverAdmin = member?.admin;

  const isMemberToMemberMessagingEnabled =
    useIsMemberToMemberMessagingEnabled();

  const isReceiverExists = member?.profile_confirmed_at && !member?.is_deleted;
  const isCurrentCommunityMemberProfile =
    currentCommunityMember?.id == member?.id;

  const isCommunityMessagingDisabled = !currentCommunity?.messaging_enabled;

  if (shouldHideMessageButton) {
    return false;
  }

  if (
    !isReceiverExists ||
    isCurrentCommunityMemberProfile ||
    isCommunityMessagingDisabled
  ) {
    return false;
  }

  if (
    isReceiverAdmin &&
    !(member.messaging_enabled_by_member && member.messaging_enabled_by_admin)
  ) {
    return false;
  }

  if (isSenderAdmin) {
    return true;
  }

  if (!isReceiverAdmin && !isSenderAdmin && !isMemberToMemberMessagingEnabled) {
    return false;
  }

  return (
    member.messaging_enabled_by_member &&
    member.messaging_enabled_by_admin &&
    currentCommunityMember?.messaging_enabled_by_member &&
    currentCommunityMember?.messaging_enabled_by_admin
  );
};
